import { createContext } from "react";
import { defaultEditorDefns, EditorDefns } from "../../utility";
import { ArsContextState, IArsContext } from "./interface";

export const arsContextInitialState: ArsContextState<unknown> = {
  // Read-only reference data
  comparators: [],
  variables: [],

  // Editable/sharable lists
  analyses: {},
  analysisMethods: {},
  analysisSets: {},
  caseWhenConditions: {},
  dataSubsets: {},
  groupingFactors: {},

  // UI state
  changed: false,
  datasetsInUse: new Set<string>(),
  disableAnalysisMethodEdit: false,
  editorDefns: defaultEditorDefns as EditorDefns<unknown>,
  uiRequestStatus: {
    requesting: false,
    error: false,
  },
  variablesInUse: new Set<string>(),

  // Sidebar state
  currentSidebar: {
    view: "groupingFactor",
    filter: "",
  },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Context consumers type this payload through useArsContext.
export const ArsContext = createContext<IArsContext<any>>({
  state: arsContextInitialState,
  dispatch:
    // istanbul ignore next
    () => {},
});
